import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  // {
  //   path: 'gest-certificado-bonif', loadChildren: './pages/gest-certificado-bonif/gest-certificado-bonif.module#GestCertificadoBonifModule'
  // },
  {
    path: 'nuevo-formulario-tupa', loadChildren: './pages/nuevo-formulario-tupa/nuevo-formulario-tupa.module#NuevoFormularioTupaModule'
  },
  {
    path: 'gestion-tupa', loadChildren: './pages/gestion-tupa/gestion-tupa.module#GestionTupaModule'
  },
  {
    path: '', loadChildren: './pages/index-tupa/index-tupa.module#IndexTupaModule'
  },
  {
    path: 'mensaje-tupa', loadChildren: './pages/mensaje-tupa/mensaje-tupa.module#MensajeTupaModule'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProcedimientosTupaRoutingModule { }
